import { React, useEffect, useState, useRef } from 'react';
import Navigation from './nav/Navigation.js';
import "aos";
import './css/aos.css';
import './css/bootstrap.css';
import './css/main.css';
import './css/glightbox.min.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import 'swiper/css';
import 'swiper/css/pagination';

function App() {
  useEffect(() => {
    AOS.init({
      duration: 600,
      easing: 'ease-in-out',
      once: true,
      mirror: false
    });
  }, []);
  return (
    <div>
      
      <Navigation/>
    </div>
  );
}

export default App;
